import { Chip } from "@mui/material";
import {
  formatDealImageTypeLabel,
  type DealImageType,
} from "../../../types/dealImages";

interface DealImageTypeChipProps {
  imageType: DealImageType | string | null | undefined;
  sx?: object;
}

export default function DealImageTypeChip({
  imageType,
  sx,
}: DealImageTypeChipProps) {
  const label = formatDealImageTypeLabel(imageType);
  if (!label) return null;

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        fontWeight: 600,
        backgroundColor: "rgba(255,255,255,0.92)",
        color: "#111827",
        boxShadow: "0 1px 3px rgba(0,0,0,0.18)",
        ...sx,
      }}
    />
  );
}
